import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=19b077da&scoped=true&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=19b077da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b077da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VTooltip})
